import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import {
    WinningPercentageService,
    WpDisplayConfig,
    WpViewTable,
} from '../../core';
import { ActionType } from '../main.action';

import { Reload, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.WP_MAIN__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service = deps.injector.get<WinningPercentageService>(
                WinningPercentageService,
            );

            // TODO change to graphql
            return forkJoin([
                service.retrieveDisplayConfig(act.payload.userId),
                service.retrieveViewTable(
                    act.payload.userId,
                    act.payload.dataRangeId,
                    act.payload.evalRangeId,
                    act.payload.drillPathId,
                ),
            ]).pipe(
                map((ret: [WpDisplayConfig, WpViewTable]) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            config: ret[0],
                            table: ret[1],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
